'use strict';

import * as types from './types';

export const addError = message => ({
	type: types.ADD_ERROR,
	data: { message }
});

export const removeError = uuid => ({
	type: types.REMOVE_ERROR,
	data: { uuid }
});
